











































import Vue from "vue";
import Component from "vue-class-component";
import { Page } from "../../services/settings/entities/page.interface";
import { Prop } from "vue-property-decorator";

@Component
export default class DeletePageDialog extends Vue {
  @Prop() page!: Page;
  @Prop() dialogDelete!: boolean;

  loadingDelete = false;

  cancelDelete(): void {
    this.$emit("cancelDelete");
  }
  get pageTranslate() {
    if (this.page?.pageNameTranslate)
      return this.page.pageNameTranslate.find((p) => p.iso == "es");
    return {};
  }
  async removePage() {
    this.loadingDelete = true;
    try {
      const response = await this.$store.dispatch("settings/deletePage", {
        pageID: this.page.pageID,
      });
      if (response) {
        this.$emit("onSuccess");
      } else {
        this.$emit("onError");
      }
    } catch (error) {
      this.$emit("onError");
    }

    this.loadingDelete = false;
    this.$emit("cancelDelete");
    this.$store.dispatch("settings/getPages");
  }
}
